import { AxnAdminUserInvitation, FormattedAxnAdminUserInvitation } from "@idw-types/data/axn-admin-user-invitation";
import { AxnAdminUserPropertyBundle } from "@idw-types/data/axn-admin-user-property-bundle";
import { AxnCompany, AxnRelyingParty } from "@idw-types/data/reference-data/axn";
import { RelyingPartyRole } from "@idw-types/common";

export const formatAxnAdminUserInvitations = (
    axnAdminUserInvitations: Array<AxnAdminUserInvitation>,
    axnAdminUserPropertyBundles: Array<AxnAdminUserPropertyBundle>,
    axnCompanies: Array<AxnCompany>,
    axnRelyingParties: Array<AxnRelyingParty>
): Array<FormattedAxnAdminUserInvitation> => {
    return axnAdminUserInvitations.map(invitation => formatAxnAdminUserInvitation(
        invitation,
        axnAdminUserPropertyBundles,
        axnCompanies,
        axnRelyingParties
    ));
};

export const formatAxnAdminUserInvitation = (
    axnAdminUserInvitation: AxnAdminUserInvitation,
    axnAdminUserPropertyBundles: Array<AxnAdminUserPropertyBundle>,
    axnCompanies: Array<AxnCompany>,
    axnRelyingParties: Array<AxnRelyingParty>
): FormattedAxnAdminUserInvitation => {
    const organizationRole = axnAdminUserPropertyBundles.find(upb => upb.id === axnAdminUserInvitation.userPropertyBundleID);
    const organization = axnCompanies.find(company => company.id === axnAdminUserInvitation.organizationID);
    
    const relyingPartyRoles: Array<RelyingPartyRole> = [];
    if (axnAdminUserInvitation.rpUserPropertyBundles) {
        axnAdminUserInvitation.rpUserPropertyBundles.forEach(rpupb => {
            const relyingParty = axnRelyingParties.find(rp => rp.id === `${rpupb.relyingPartyID}`);
            const bundle = axnAdminUserPropertyBundles.find(pb => pb.id === `${rpupb.userPropertyBundleID}`);

            if (relyingParty && bundle) {
                relyingPartyRoles.push({
                    relyingParty,
                    bundle: bundle
                });
            }
        });
    }

    let createdDate = null;
    if (axnAdminUserInvitation.createdDate) {
        createdDate = new Date(parseInt(axnAdminUserInvitation.createdDate));
    }

    return {
        createdDate: createdDate,
        email: axnAdminUserInvitation.email,
        id: axnAdminUserInvitation.id,
        inviterID: axnAdminUserInvitation.inviterID,
        inviterName: axnAdminUserInvitation.inviterName,
        organizationName: axnAdminUserInvitation.organizationName,
        organization: organization,
        status: axnAdminUserInvitation.status,
        organizationRole,
        relyingPartyRoles,
        permissions: axnAdminUserInvitation.permissions
    };
};